import { Loader, Text } from "@mantine/core";
import { useContext } from "react";
import { useParams } from "react-router-dom";

import { useGetEvent } from "../../../api/event";
import { AuthContext } from "../../../services/context";
import EditForm from "./Form";
import { useGetAllFeatureFlags } from "../../../api/featureFlags";

export default function Edit() {
  const { user } = useContext(AuthContext);
  const { id } = useParams();
  const isSysAdmin = user?.role === "sysAdmin";

  const {
    data: responseData,
    isPending: isLoading,
    isError,
    error,
  } = useGetEvent(id);

  const { data: featureFlags, isPending: isLoadingFlags } =
    useGetAllFeatureFlags({ eventId: id });

  const createdFlags = featureFlags?.map((flag) => flag.featureName) ?? [];

  let content;
  if (isLoading || isLoadingFlags) {
    content = <Loader mt={10} />;
  } else if (isError) {
    content = <Text c="red">{error.message}</Text>;
  } else if (responseData) {
    content = (
      <EditForm
        data={responseData}
        isSysAdmin={isSysAdmin}
        enabledFlags={createdFlags}
      />
    );
  }

  return content;
}
